// Category icon component for exploit rule categories

export function CategoryIcon({ name }: { name: string }) {
  const iconMap: Record<string, string> = {
    sql_injection: 'text-red-600 dark:text-red-400 bg-red-100 dark:bg-red-900/30',
    xss: 'text-purple-600 dark:text-purple-400 bg-purple-100 dark:bg-purple-900/30',
    rfi: 'text-orange-600 dark:text-orange-400 bg-orange-100 dark:bg-orange-900/30',
    path_traversal: 'text-yellow-600 dark:text-yellow-400 bg-yellow-100 dark:bg-yellow-900/30',
    scanner: 'text-pink-600 dark:text-pink-400 bg-pink-100 dark:bg-pink-900/30',
    http_method: 'text-blue-600 dark:text-blue-400 bg-blue-100 dark:bg-blue-900/30',
    custom: 'text-slate-600 dark:text-slate-400 bg-slate-100 dark:bg-slate-800',
  };

  const labelMap: Record<string, string> = {
    sql_injection: 'SQL',
    xss: 'XSS',
    rfi: 'RFI',
    path_traversal: 'PTH',
    scanner: 'SCN',
    http_method: 'HTTP',
    custom: 'CUS',
  };

  const colorClass = iconMap[name] || 'text-slate-600 dark:text-slate-400 bg-slate-100 dark:bg-slate-800';

  return (
    <div className={`w-8 h-8 rounded flex items-center justify-center text-xs font-bold ${colorClass}`}>
      {labelMap[name] || name.slice(0, 3).toUpperCase()}
    </div>
  );
}
